// assets/pantribot.js
(function () {
  const API = (window.PANTRIBOT_API || "https://api.pantribot.com").replace(/\/+$/, "");
  const CUSTOMER_ID = (window.PANTRIBOT_CUSTOMER && window.PANTRIBOT_CUSTOMER.id) || null;

  // --- Persistence keys ---
  const LS_TOKEN = "ptb_token";
  const LS_EXPIRES_AT = "ptb_expires_at"; // epoch seconds
  const LS_ZIP = "ptb_zip";

  // UI session restore (query/options) across login/register redirects
  const LS_RETURN_STATE = "ptb_return_state_v1";

  // restore state when user opens product and comes back (back button / normal nav)
  const LS_LAST_STATE = "ptb_last_state_v1";

  // Draft persistence across visits
  const LS_DRAFTS = "ptb_drafts_v2";

  // Product meta cache (thumbnails/tags) via /products/<handle>.js
  const LS_PRODUCT_META = "ptb_product_meta_v1";

  // IMPORTANT: keep this SHORT because tags can change after publish
  const PRODUCT_META_TTL_MS = 10 * 60 * 1000; // 10 minutes

  // --- Elements ---
  const els = {};
  function $(id) { return document.getElementById(id); }
  function nowSec() { return Math.floor(Date.now() / 1000); }
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  function setStatus(text) {
    if (els.status) els.status.textContent = text || "";
  }

  // --- Smooth progress driver (creeps to cap until told to finish) ---
  function createSmoothProgress({ set, cap = 90, speedPerSec = 18 }) {
    let running = false;
    let pct = 0;
    let raf = 0;
    let last = 0;

    function step(t) {
      if (!running) return;
      if (!last) last = t;
      const dt = (t - last) / 1000;
      last = t;

      const remaining = Math.max(1, cap - pct);
      const eased = speedPerSec * dt * (remaining / cap);
      pct = clamp(pct + eased, 0, cap);

      set(Math.round(pct));
      raf = requestAnimationFrame(step);
    }

    return {
      start(initialPct = 0) {
        running = true;
        pct = clamp(initialPct, 0, cap);
        last = 0;
        set(Math.round(pct));
        raf = requestAnimationFrame(step);
      },
      stop() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
      },
      finish() {
        running = false;
        if (raf) cancelAnimationFrame(raf);
        pct = 100;
        set(100);
      },
      setCap(newCap) { cap = clamp(newCap, 1, 99); },
    };
  }

  // --- Global plan progress helpers ---
  function showPlanProgress(text) {
    els.planProgress.style.display = "block";
    els.planProgressText.textContent = text || "Working…";
  }
  function setPlanProgress(pct) {
    const p = clamp(pct, 0, 100);
    els.planProgressFill.style.width = p + "%";
    els.planProgressPct.textContent = p + "%";
  }
  function hidePlanProgress() {
    els.planProgress.style.display = "none";
    setPlanProgress(0);
    els.planProgressText.textContent = "";
  }

  // --- Zip ---
  function getZip() {
    const raw = (els.zip && els.zip.value ? els.zip.value : "").trim();
    const cleaned = raw.replace(/\D/g, "").slice(0, 5);
    return cleaned || null;
  }

  // --- Token storage ---
  function getStoredToken() {
    const token = localStorage.getItem(LS_TOKEN) || "";
    const expiresAt = parseInt(localStorage.getItem(LS_EXPIRES_AT) || "0", 10);
    return { token, expiresAt };
  }
  function setStoredToken(token, expiresAt) {
    localStorage.setItem(LS_TOKEN, token || "");
    localStorage.setItem(LS_EXPIRES_AT, String(expiresAt || 0));
  }
  function clearStoredToken() {
    localStorage.removeItem(LS_TOKEN);
    localStorage.removeItem(LS_EXPIRES_AT);
  }
  function tokenIsValid(expiresAt) {
    return expiresAt && (expiresAt - 30) > nowSec();
  }

  async function apiFetch(path, opts = {}) {
    return fetch(`${API}${path}`, opts);
  }

  // --- Return + restore (login/register AND normal navigation) ---
  // Shopify sometimes drops fragments (#...) during account redirects.
  // return_url includes only path+search; we restore hash+scroll from state.
  function buildReturnUrl() {
    const here = window.location.pathname + window.location.search; // no hash
    return encodeURIComponent(here);
  }

  function currentScrollY() {
    return Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0));
  }

  function saveReturnState({ q, z, items, checked } = {}) {
    const state = {
      v: 1,
      at: Date.now(),
      path: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      scrollY: currentScrollY(),
      q: q || "",
      z: z || "",
      items: Array.isArray(items) ? items : [],
      checked: Array.isArray(checked) ? checked : [],
    };

    localStorage.setItem(LS_RETURN_STATE, JSON.stringify(state));
    localStorage.setItem(LS_LAST_STATE, JSON.stringify(state));
  }

  function loadReturnState() {
    try {
      const raw = localStorage.getItem(LS_RETURN_STATE);
      if (!raw) return null;
      const st = JSON.parse(raw);
      if (!st || st.v !== 1) return null;
      return st;
    } catch {
      return null;
    }
  }

  function loadLastState() {
    try {
      const raw = localStorage.getItem(LS_LAST_STATE);
      if (!raw) return null;
      const st = JSON.parse(raw);
      if (!st || st.v !== 1) return null;
      return st;
    } catch {
      return null;
    }
  }

  function clearReturnState() {
    localStorage.removeItem(LS_RETURN_STATE);
  }

  function restoreScrollAndHash(st) {
    if (!st) return;

    if (st.hash && typeof st.hash === "string") {
      try {
        if (window.location.hash !== st.hash) window.location.hash = st.hash;
      } catch {}
    }

    const y = Number(st.scrollY || 0);
    if (!Number.isFinite(y)) return;

    const apply = () => { try { window.scrollTo(0, y); } catch {} };

    requestAnimationFrame(apply);
    setTimeout(apply, 0);
    setTimeout(apply, 120);
    setTimeout(apply, 420);
    setTimeout(apply, 900);

    window.addEventListener("load", () => {
      setTimeout(apply, 60);
      setTimeout(apply, 240);
    }, { once: true });
  }

  // If we're on /account/login or /account/register, inject hidden return fields into forms.
  function ensureAccountFormReturnField() {
    const path = String(window.location.pathname || "");
    const isAccountPage =
      path.indexOf("/account/login") === 0 ||
      path.indexOf("/account/register") === 0 ||
      path.indexOf("/account") === 0;

    if (!isAccountPage) return;

    const st = loadReturnState() || loadLastState();
    if (!st) return;

    const returnPath = (st.path || "/") + (st.search || "");
    const forms = document.querySelectorAll('form[action^="/account"]');

    for (const form of forms) {
      const addHidden = (name) => {
        try {
          let input = form.querySelector(`input[name="${name}"]`);
          if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            form.appendChild(input);
          }
          input.value = returnPath;
        } catch {}
      };

      addHidden("return_url");
      addHidden("return_to");
    }
  }

  function updateLoginLink() {
    const returnUrl = buildReturnUrl();
    if (els.loginLink) els.loginLink.href = `/account/login?return_url=${returnUrl}`;
    if (els.openAccount) els.openAccount.dataset.ptbRegisterHref = `/account/register?return_url=${returnUrl}`;
  }

  // --- Sign-in nudge ---
  function showSigninNudge({ q }) {
    els.signin.style.display = "block";
    setStatus("Sign in required.");
    updateLoginLink();

    const z = getZip() || localStorage.getItem(LS_ZIP) || "";
    saveReturnState({ q, z, items: [], checked: [] });

    const candidates = [
      'a[href*="/account"]',
      'a[href="/account"]',
      'a[href="/account/login"]',
      'button[aria-label*="Account"]',
      'summary[aria-label*="Account"]',
      ".header__icon--account",
      ".header__account",
    ];

    let accountEl = null;
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) { accountEl = el; break; }
    }

    if (accountEl) {
      accountEl.classList.add("ptb2-pulse");
      try { accountEl.click(); } catch {}
      setTimeout(() => accountEl.classList.remove("ptb2-pulse"), 4500);
    }
  }

  // --- Auth endpoints ---
  async function authExchange() {
    if (!CUSTOMER_ID) return null;

    const qs = `?user_id=${encodeURIComponent(String(CUSTOMER_ID))}`;
    const res = await apiFetch(`/v1/auth/exchange${qs}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    if (!res.ok) throw new Error(`auth/exchange failed: HTTP ${res.status}`);
    const data = await res.json();

    if (!data || !data.token || !data.expires_at) throw new Error("auth/exchange missing token/expires_at");
    setStoredToken(data.token, Number(data.expires_at));
    return data.token;
  }

  async function authRefresh() {
    const { token } = getStoredToken();
    if (!token) return null;

    const res = await apiFetch(`/v1/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!res.ok) return null;

    const data = await res.json();
    if (data && data.token && data.expires_at) {
      setStoredToken(data.token, Number(data.expires_at));
      return data.token;
    }
    return null;
  }

  async function getAuthToken() {
    const { token, expiresAt } = getStoredToken();
    if (token && tokenIsValid(expiresAt)) return token;

    const refreshed = await authRefresh();
    if (refreshed) return refreshed;

    clearStoredToken();
    return await authExchange();
  }

  // --- Plan/route ---
  async function planRoute(q) {
    const token = await getAuthToken();
    if (!token) throw new Error("No token available");

    const qs = `?q=${encodeURIComponent(q)}`;
    const res = await apiFetch(`/v1/plan/route${qs}`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (res.status === 401) {
      const refreshed = await authRefresh();
      if (!refreshed) {
        clearStoredToken();
        await authExchange();
      }
      const token2 = (getStoredToken().token || refreshed);

      const res2 = await apiFetch(`/v1/plan/route${qs}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token2}`,
          "Content-Type": "application/json",
        },
      });

      if (!res2.ok) throw new Error(`plan/route failed after retry: HTTP ${res2.status}`);
      return await res2.json();
    }

    if (!res.ok) throw new Error(`plan/route failed: HTTP ${res.status}`);
    return await res.json();
  }

  function normalizeItems(plan) {
    const arr = Array.isArray(plan && plan.items) ? plan.items : (plan && plan.items ? [plan.items] : []);
    return arr.map((x) => (x == null ? "" : String(x))).filter(Boolean);
  }

  // --- Draft persistence ---
  function loadDraftsMap() {
    try {
      const raw = localStorage.getItem(LS_DRAFTS);
      if (!raw) return {};
      const obj = JSON.parse(raw);
      return obj && typeof obj === "object" ? obj : {};
    } catch {
      return {};
    }
  }

  function saveDraftsMap(map) {
    localStorage.setItem(LS_DRAFTS, JSON.stringify(map || {}));
  }

  function makeDraftKey({ q, z, optionText }) {
    return `${(q || "").trim().toLowerCase()}|${(z || "").trim()}|${(optionText || "").trim().toLowerCase()}`;
  }

  function upsertDraft(draft) {
    const map = loadDraftsMap();
    map[draft.key] = draft;
    saveDraftsMap(map);
  }

  // --- Product meta cache (/products/<handle>.js) ---
  function loadProductMetaCache() {
    try {
      const raw = localStorage.getItem(LS_PRODUCT_META);
      if (!raw) return {};
      const obj = JSON.parse(raw);
      return obj && typeof obj === "object" ? obj : {};
    } catch {
      return {};
    }
  }

  function saveProductMetaCache(map) {
    localStorage.setItem(LS_PRODUCT_META, JSON.stringify(map || {}));
  }

  function parseHandleFromUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      const parts = (u.pathname || "").split("/").filter(Boolean);
      const idx = parts.indexOf("products");
      if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
      return null;
    } catch {
      return null;
    }
  }

  async function fetchProductMeta(handle, { force = false } = {}) {
    if (!handle) return null;

    const cache = loadProductMetaCache();
    const hit = cache[handle];

    if (!force && hit && hit.at && (Date.now() - hit.at) < PRODUCT_META_TTL_MS) return hit;

    try {
      const bust = force ? `?t=${Date.now()}` : "";
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js${bust}`, { credentials: "same-origin" });
      if (!res.ok) return hit || null;

      const data = await res.json();
      const img =
        (data && data.featured_image) ||
        (Array.isArray(data && data.images) && data.images[0]) ||
        null;

      const tags = Array.isArray(data && data.tags) ? data.tags : [];
      const meta = {
        at: Date.now(),
        title: (data && data.title) || "",
        img: img || null,
        tags,
      };

      cache[handle] = meta;
      saveProductMetaCache(cache);
      return meta;
    } catch {
      return hit || null;
    }
  }

  function statusFromTags(tags, fallback = "") {
    const t = (tags || []).map((s) => String(s || "").toLowerCase());
    if (t.includes("active")) return "active";
    if (t.includes("unlisted")) return "unlisted";
    return fallback || "";
  }

  function statusLabel(status) {
    const s = String(status || "").toLowerCase();
    if (s === "active") return "Active.";
    return "Unlisted until you approve.";
  }

  // ✅ NEW: always refresh status for an existing draft option by reading product tags
  async function refreshExistingOptionFromMeta({ key, existing, smallEl, thumbEl }) {
    try {
      const handle = existing.handle || parseHandleFromUrl(existing.url);
      if (!handle) return;

      // Force fetch so publish/tag changes show immediately
      const meta = await fetchProductMeta(handle, { force: true });
      if (!meta) return;

      const nextStatus = statusFromTags(meta.tags, existing.status);
      const nextImg = meta.img || existing.img || null;

      // Update UI
      if (smallEl) smallEl.textContent = statusLabel(nextStatus);
      if (thumbEl && nextImg) {
        thumbEl.src = nextImg;
        thumbEl.style.display = "block";
      }

      // Persist back into LS_DRAFTS
      const map = loadDraftsMap();
      if (map[key]) {
        map[key].handle = handle;
        map[key].status = nextStatus || map[key].status || "";
        map[key].img = nextImg || map[key].img || null;
        saveDraftsMap(map);
      }
    } catch {}
  }

  // --- Drafts panel (Your recipes) ---
  function renderDraftsPanel() {
    const map = loadDraftsMap();
    const list = Object.values(map).sort((a, b) => (b.created_at || 0) - (a.created_at || 0));

    if (!list.length) {
      els.drafts.style.display = "none";
      els.drafts.innerHTML = "";
      return;
    }

    els.drafts.style.display = "block";
    els.drafts.innerHTML = "";

    const title = document.createElement("div");
    title.className = "ptb2-resultsTitle";
    title.textContent = "Your recipes";

    const wrap = document.createElement("div");
    wrap.className = "ptb2-draftsList";

    list.slice(0, 12).forEach((d) => {
      const row = document.createElement("div");
      row.className = "ptb2-draftRow";

      const left = document.createElement("div");
      left.className = "ptb2-draftLeft";

      const img = document.createElement("img");
      img.className = "ptb2-thumb";
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";
      img.style.display = d.img ? "block" : "none";
      if (d.img) img.src = d.img;

      const textWrap = document.createElement("div");
      textWrap.className = "ptb2-draftText";

      const name = document.createElement("div");
      name.className = "ptb2-draftTitle";
      name.textContent = d.optionText || d.q || "Recipe";

      const sub = document.createElement("div");
      sub.className = "ptb2-small";
      const st = String(d.status || "").toLowerCase();
      sub.textContent = `ZIP ${d.z || ""}${st ? " • " + st : ""}`;

      textWrap.appendChild(name);
      textWrap.appendChild(sub);

      left.appendChild(img);
      left.appendChild(textWrap);

      const right = document.createElement("div");
      if (d.url) {
        const a = document.createElement("a");
        a.className = "ptb2-link";
        a.href = d.url;
        a.textContent = "Open";

        a.addEventListener("click", () => {
          const st2 = loadLastState() || {};
          saveReturnState({
            q: st2.q || (els.input && els.input.value ? String(els.input.value).trim() : ""),
            z: st2.z || (getZip() || localStorage.getItem(LS_ZIP) || ""),
            items: Array.isArray(st2.items) ? st2.items : [],
            checked: Array.isArray(st2.checked) ? st2.checked : [],
          });
        });

        right.appendChild(a);
      }

      row.appendChild(left);
      row.appendChild(right);
      wrap.appendChild(row);
    });

    els.drafts.appendChild(title);
    els.drafts.appendChild(wrap);
  }

  // --- Draft/start ---
  async function draftStart(optionText) {
    const token = await getAuthToken();
    const q = optionText;
    const qs = `?q=${encodeURIComponent(q)}`;

    const res = await apiFetch(`/v1/draft/start${qs}`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (res.status === 401) {
      const refreshed = await authRefresh();
      if (!refreshed) {
        clearStoredToken();
        await authExchange();
      }
      const token2 = (getStoredToken().token || refreshed);

      const res2 = await apiFetch(`/v1/draft/start${qs}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token2}`,
          "Content-Type": "application/json",
        },
      });

      if (!res2.ok) throw new Error(`draft/start failed after retry: HTTP ${res2.status}`);
      return await res2.json();
    }

    if (!res.ok) throw new Error(`draft/start failed: HTTP ${res.status}`);
    return await res.json();
  }

  async function enrichDraftWithProductMeta(draft, { force = false } = {}) {
    const handle = draft.handle || parseHandleFromUrl(draft.url);
    if (!handle) return draft;

    const meta = await fetchProductMeta(handle, { force });
    if (!meta) return Object.assign({}, draft, { handle });

    const status = statusFromTags(meta.tags, draft.status);
    return Object.assign({}, draft, {
      handle,
      img: meta.img || draft.img || null,
      status: status || draft.status || "",
    });
  }

  async function hydrateDraftsOnLoad() {
    const map = loadDraftsMap();
    const keys = Object.keys(map);
    if (!keys.length) return;

    let changed = false;

    const slice = keys.slice(0, 12);
    for (const k of slice) {
      const d = map[k];
      if (!d || !d.url) continue;

      // Force if not active, so publish changes update faster
      const force = String(d.status || "").toLowerCase() !== "active";
      const needs = !d.img || !d.status || !d.handle || force;
      if (!needs) continue;

      const updated = await enrichDraftWithProductMeta(d, { force });
      map[k] = updated;
      changed = true;
    }

    if (changed) saveDraftsMap(map);
  }

  // --- Results rendering ---
  function renderResults({ q, z, plan }) {
    const items = normalizeItems(plan);
    if (!items.length) {
      els.results.style.display = "none";
      els.results.innerHTML = "";
      setStatus("No options returned.");
      return;
    }

    els.results.style.display = "block";
    els.results.innerHTML = "";

    const title = document.createElement("div");
    title.className = "ptb2-resultsTitle";
    title.textContent = plan.type === "single" ? "Option:" : "Options:";

    const list = document.createElement("div");
    list.className = "ptb2-list";

    const draftsMap = loadDraftsMap();

    items.forEach((text) => {
      const card = document.createElement("div");
      card.className = "ptb2-item";

      const row = document.createElement("div");
      row.className = "ptb2-itemRow";

      const left = document.createElement("div");
      left.className = "ptb2-itemLeft";

      const name = document.createElement("div");
      name.style.fontWeight = "900";
      name.style.fontSize = "14px";
      name.textContent = text;

      const small = document.createElement("div");
      small.className = "ptb2-small";

      left.appendChild(name);
      left.appendChild(small);

      const right = document.createElement("div");
      right.className = "ptb2-itemRight";

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ptb2-btn primary";
      btn.textContent = "Build draft";

      const inlineProg = document.createElement("div");
      inlineProg.className = "ptb2-progressInline";
      inlineProg.style.display = "none";

      const progTrack = document.createElement("div");
      progTrack.className = "ptb2-progressTrack ptb2-progressTrackInline";

      const progFill = document.createElement("div");
      progFill.className = "ptb2-progressFill";
      progTrack.appendChild(progFill);

      const progPct = document.createElement("div");
      progPct.className = "ptb2-progressPctInline";
      progPct.textContent = "0%";

      inlineProg.appendChild(progTrack);
      inlineProg.appendChild(progPct);

      const thumb = document.createElement("img");
      thumb.className = "ptb2-thumb";
      thumb.alt = "";
      thumb.loading = "lazy";
      thumb.decoding = "async";
      thumb.style.display = "none";

      const openLink = document.createElement("a");
      openLink.className = "ptb2-link";
      openLink.style.display = "none";
      openLink.target = "_self";
      openLink.rel = "noopener";
      openLink.textContent = "Open";

      openLink.addEventListener("click", () => {
        saveReturnState({ q, z, items, checked: [] });
      });

      right.appendChild(btn);
      right.appendChild(inlineProg);
      right.appendChild(thumb);
      right.appendChild(openLink);

      row.appendChild(left);
      row.appendChild(right);
      card.appendChild(row);

      const setItemPct = (p) => {
        const pct = clamp(p, 0, 100);
        progFill.style.width = pct + "%";
        progPct.textContent = pct + "%";
      };

      const smooth = createSmoothProgress({ set: setItemPct, cap: 90, speedPerSec: 20 });

      const key = makeDraftKey({ q, z, optionText: text });
      const existing = draftsMap[key];

      small.textContent = "Unlisted until you approve.";

      if (existing && existing.url) {
        btn.style.display = "none";
        openLink.href = existing.url;
        openLink.style.display = "inline-flex";

        // Initial label from stored status
        small.textContent = statusLabel(existing.status);

        if (existing.img) {
          thumb.src = existing.img;
          thumb.style.display = "block";
        }

        // ✅ ALWAYS refresh status from Shopify tags (fixes published vs unlisted in Options list)
        refreshExistingOptionFromMeta({
          key,
          existing,
          smallEl: small,
          thumbEl: thumb,
        });
      }

      btn.addEventListener("click", async () => {
        btn.disabled = true;
        setItemPct(0);

        btn.style.display = "none";
        thumb.style.display = "none";
        openLink.style.display = "none";
        inlineProg.style.display = "flex";

        smooth.start(0);

        saveReturnState({ q, z, items, checked: [] });

        try {
          const data = await draftStart(text);

          smooth.finish();

          setTimeout(async () => {
            inlineProg.style.display = "none";

            const url = (data && data.url) || "";
            const statusApi = String((data && data.status) || "").toLowerCase();
            const id = (data && data.id) || null;
            const handle = parseHandleFromUrl(url);

            let draft = {
              key,
              q,
              z,
              optionText: text,
              id,
              url,
              status: statusApi || "unlisted",
              created_at: Date.now(),
              handle: handle || null,
              img: null,
            };

            draft = await enrichDraftWithProductMeta(draft, { force: true });

            if (draft.img) {
              thumb.src = draft.img;
              thumb.style.display = "block";
            }
            if (draft.url) {
              openLink.href = draft.url;
              openLink.style.display = "inline-flex";
            }

            small.textContent = statusLabel(draft.status);

            upsertDraft(draft);
            renderDraftsPanel();

            saveReturnState({ q, z, items, checked: [] });
          }, 150);
        } catch (e) {
          smooth.stop();
          console.error("draft/start error", e);

          inlineProg.style.display = "none";
          btn.style.display = "inline-flex";
          btn.disabled = false;
        } finally {
          if (btn.style.display !== "none") btn.disabled = false;
        }
      });

      list.appendChild(card);
    });

    const clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "ptb2-btn";
    clearBtn.textContent = "Clear results";
    clearBtn.style.marginTop = "12px";
    clearBtn.addEventListener("click", () => {
      els.results.style.display = "none";
      els.results.innerHTML = "";
      setStatus("");
      saveReturnState({ q: "", z: getZip() || "", items: [], checked: [] });
    });

    els.results.appendChild(title);
    els.results.appendChild(list);
    els.results.appendChild(clearBtn);

    saveReturnState({ q, z, items, checked: [] });
  }

  async function onSend() {
    const q = (els.input && els.input.value ? els.input.value : "").trim();
    if (!q) return;

    const zip = getZip();
    if (zip) localStorage.setItem(LS_ZIP, zip);
    const z = zip || localStorage.getItem(LS_ZIP) || "";

    if (!CUSTOMER_ID) {
      showSigninNudge({ q });
      return;
    }

    els.signin.style.display = "none";
    els.results.style.display = "none";
    els.results.innerHTML = "";
    setStatus("");

    showPlanProgress("Planning options…");
    setPlanProgress(0);

    const smoothPlan = createSmoothProgress({ set: setPlanProgress, cap: 92, speedPerSec: 16 });
    smoothPlan.start(0);

    try {
      await getAuthToken();
      const plan = await planRoute(q);

      smoothPlan.finish();
      els.planProgressText.textContent = "Ready.";
      setTimeout(() => hidePlanProgress(), 250);

      renderResults({ q, z, plan });
      setStatus(plan.type === "single" ? "1 option found." : "Options found.");
    } catch (err) {
      smoothPlan.stop();
      hidePlanProgress();
      console.error("PantriBot error:", err);
      setStatus("Something failed. Check console.");
    }
  }

  function restoreAfterLoginIfNeeded() {
    if (!CUSTOMER_ID) return;

    const st = loadReturnState();
    if (!st) return;

    if (st.q && els.input) els.input.value = st.q;
    if (st.z && els.zip) els.zip.value = st.z;

    if (Array.isArray(st.items) && st.items.length) {
      const plan = { type: st.items.length === 1 ? "single" : "multi", items: st.items };
      renderResults({ q: st.q || "", z: st.z || "", plan });
      setStatus("Welcome back — your options were restored.");
    }

    restoreScrollAndHash(st);
    clearReturnState();
  }

  function restoreAfterBackNavIfNeeded() {
    const st = loadLastState();
    if (!st) return;

    if (st.q && els.input) els.input.value = st.q;
    if (st.z && els.zip) els.zip.value = st.z;

    if (CUSTOMER_ID && Array.isArray(st.items) && st.items.length) {
      const plan = { type: st.items.length === 1 ? "single" : "multi", items: st.items };
      renderResults({ q: st.q || "", z: st.z || "", plan });
      setStatus("");
    }

    restoreScrollAndHash(st);
  }

  async function boot() {
    els.input = $("ptb2-input");
    els.send = $("ptb2-send");
    els.zip = $("ptb2-zip");
    els.results = $("ptb2-results");
    els.status = $("ptb2-status");
    els.signin = $("ptb2-signin");
    els.openAccount = $("ptb2-openAccount");
    els.loginLink = $("ptb2-loginLink");

    els.planProgress = $("ptb2-planProgress");
    els.planProgressFill = $("ptb2-planProgressFill");
    els.planProgressText = $("ptb2-planProgressText");
    els.planProgressPct = $("ptb2-planProgressPct");

    els.drafts = $("ptb2-drafts");

    ensureAccountFormReturnField();

    if (!els.input || !els.send || !els.results) return;

    const storedZip = localStorage.getItem(LS_ZIP);
    const zip = window.PANTRIBOT_CUSTOMER_ZIP || storedZip || "";
    if (els.zip && zip) els.zip.value = String(zip);

    updateLoginLink();

    els.send.addEventListener("click", onSend);
    els.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") onSend();
    });

    if (els.openAccount) {
      els.openAccount.addEventListener("click", () => {
        const q = (els.input && els.input.value ? els.input.value : "").trim();
        const zipNow = getZip();
        if (zipNow) localStorage.setItem(LS_ZIP, zipNow);
        const z = zipNow || localStorage.getItem(LS_ZIP) || "";

        saveReturnState({ q, z, items: [], checked: [] });
        updateLoginLink();

        const href = els.openAccount.dataset.ptbRegisterHref || `/account/register?return_url=${buildReturnUrl()}`;
        window.location.href = href;
      });
    }

    await hydrateDraftsOnLoad();
    renderDraftsPanel();

    restoreAfterLoginIfNeeded();
    restoreAfterBackNavIfNeeded();

    window.addEventListener("pageshow", (e) => {
      if (e && e.persisted) {
        try { restoreAfterBackNavIfNeeded(); } catch {}
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => { boot(); });
})();
